import { useCurrCompany, useUpdateCompany } from '../../domains/companies/company.service';
import { FirmProfilePage } from './firm-profile-page.component';
import { Loader } from '../../_core/loader.component';
import { useCompanyInvites } from '../../domains/invite/invite.service';
import { useCompanyMembers, useCurrMember, useRemoveSelf } from '../../domains/member/member.service';
import { useCompanyLocations } from '../../domains/locations/location.service';
import { useCompanyDepartments } from '../../domains/departments/department.service';
import { useCompanyRequestTypes, useSelectedRequestTypes } from '../../domains/request-type/request-type.service';
import { useFetchCurrUser } from '../../domains/users/user.service';
import { useQueryParams } from '../../../services/routing.service';
import { showError } from '../../../lib/utils';
import { USER_COMPANIES_REFETCH_QUERIES } from '../../domains/companies/company.const';
import { FirmProfilePageTableMode } from './firm-profile-page.types';

export const FirmProfilePageContainer = () => {
  const { user } = useFetchCurrUser();

  const { departments, loading: loadingDepartments } = useCompanyDepartments();
  const { invites, loading: loadingInvites } = useCompanyInvites();
  const { locations, loading: loadingLocations } = useCompanyLocations();
  const { members, loading: loadingMembers } = useCompanyMembers();
  const { company, isPersonal } = useCurrCompany();
  const { currMember, isAdmin } = useCurrMember();

  const { companyRequestTypes, loading: loadingCompanyTypes } = useCompanyRequestTypes();
  const { requestTypes, loading: loadingSelectedTypes } = useSelectedRequestTypes();

  const { removeSelf, loading: removingSelf } = useRemoveSelf();
  const { updateCompany, loading: updating } = useUpdateCompany(USER_COMPANIES_REFETCH_QUERIES);

  const params = useQueryParams();
  const completeOnboarding = params.get('complete-onboarding') === 'true';

  const defaultTab = params.get('table');
  let defaulTabAsEnum: FirmProfilePageTableMode | null = null;
  if (defaultTab) {
    defaulTabAsEnum =
      (Object.entries(FirmProfilePageTableMode).find(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ([_, value]) => value.toLowerCase() === defaultTab.toLowerCase()
      )?.[0] as FirmProfilePageTableMode) ?? null;
  }

  if (!user || !company) return <Loader />;

  return (
    <div className="flex min-h-full flex-1 flex-col items-center">
      <FirmProfilePage
        company={company}
        isAdmin={isAdmin}
        isPersonalCompany={isPersonal}
        completeOnboarding={completeOnboarding}
        updateCompany={(props) => {
          // TODO: Currently only used for activating/deactivating firm, would not need a query refetch on other types of Firm updates in the future
          try {
            updateCompany(props);
          } catch (err) {
            showError('Unable to update organization', err as Error);
          }
        }}
        updating={updating}
        departments={departments ?? []}
        invites={invites}
        loadingDepartments={loadingDepartments}
        loadingLocations={loadingLocations}
        loadingStaff={loadingInvites || loadingMembers}
        loadingTypes={loadingCompanyTypes || loadingSelectedTypes}
        locations={locations ?? []}
        members={members}
        inactiveCompanyRequestTypes={companyRequestTypes?.filter(({ deletedAt }) => deletedAt) ?? []}
        selectedRequestTypes={requestTypes ?? []}
        user={user}
        removeSelf={() => {
          try {
            removeSelf();
          } catch (err) {
            showError('Unable to remove self from organization', err as Error);
          }
        }}
        removingSelf={removingSelf}
        currMember={currMember}
        defaultTab={defaulTabAsEnum}
      />
    </div>
  );
};
